import { OpenSansText } from "@Components/CustomText/OpenSansText"
import TopicHeader from "@Components/CustomTopicContent/TopicHeader"
import { baseFontFamily } from "@Constants/baseStyles"
import React, { useState } from "react"
import { View } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"
import styles from "./styles"

const TopicContentHeader = (props) => {
    const { forumId, setUpdateList, forumContent } = props

    return (
        <View>
            <TopicHeader forumId={forumId} setUpdateList={setUpdateList} headerData={forumContent} />

            {forumContent?.answers?.length > 0 && (
                <OpenSansText
                    style={styles.messagesNumber}
                    defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                    fontSize={RFValue(16)}
                >
                    {`${forumContent?.answers?.length} réponse${forumContent?.answers?.length > 1 ? "s" : ""}`}
                </OpenSansText>
            )}
        </View>
    )
}

export default TopicContentHeader
